module.exports = __webpack_public_path__ + "img/light-mud-decal-03.65cdd547.png";